export const environment = {
  production: true,
  debug: false,
  apiBaseUrl: '',
};

